import { availableCourses } from "../../courses/CourseConstants";
import vivekMentorIcon from "../../img/vivek-mentor-img.png";
import vivekMentorIconMob from "../../img/vivek-mentor-img-mob.png";


const MentorHeadings = {
    [availableCourses.PYTHON]:
        <h2 className="python-mentor-heading">
            Learn with <strong>
                Industry Experienced Mentor</strong>
        </h2>,
    [availableCourses.LLD]:
        <h2 className="lld-mentor-heading">
            Learn with <span className="blue-heading-tag">
                Industry Experienced Mentor</span>
        </h2>,
    [availableCourses.CPP]:
        <h2 className="cpp-mentor-heading">
            Learn with <br className="mentor-line-break" />
            Industry Experienced Mentor
        </h2>,
    [availableCourses.RENAISSANCE]:
        <h2 className="ren-mentor-heading">
            Learn with <br className="mentor-line-break" />
            Industry Experienced Mentor
        </h2>,
    [availableCourses.CRASH_COURSE]:
        <h2 className="dsa-mentor-heading">
            Learn with <br className="mentor-line-break" />
            Industry Experienced Mentor
        </h2>,
};

const MentorCardDetails =
{
    img: vivekMentorIcon,
    imgMob: vivekMentorIconMob,
    link: "https://www.linkedin.com/in/vivekanand-vivek-7a4ab388/",
    name: "Vivekanand Vivek",
    description: (
        <p>
            Vivek has taught <span className="mentor-bold-text">10,000+</span> students through on campus workshops and
            online courses on Interview Preparation. He has worked at{" "}
            <span className="mentor-bold-text">Amazon with its High Scale Systems for three years</span> after graduating
            from IIT. He is loved by his students for his lucid in-depth explanations and
            ability to make people think through problems.
        </p>
    ),
    gmail: "mailto:vivek@programmingpathshala.com",
};

export { MentorCardDetails, MentorHeadings };
